import { useLocation } from 'react-router';
import { NafLocationSlugs } from '@appTypes/nafLocations';
import { SiteStructureType } from '../../../../types/siteStructureType';
import { useSiteStructure } from '../../hooks/SiteStructure/useSiteStructure';

const locations: { name: string; slug: NafLocationSlugs }[] = [
  { name: 'Lokalavdelinger', slug: NafLocationSlugs.localDepartment },
  { name: 'MC-klubb', slug: NafLocationSlugs.mcClubs },
  { name: 'NAF Senter', slug: NafLocationSlugs.nafCenter },
  { name: 'Øvingsbaner', slug: NafLocationSlugs.practiceTracks },
  { name: 'Arrangementer', slug: NafLocationSlugs.events },
];

type LocationsMapType = Record<NafLocationSlugs, { slug: NafLocationSlugs; fullUrl: string; name: string }>;
type ReturnType = { locations: LocationsMapType } & SiteStructureType;

// enrich the static locations array above with the fullUrl from the siteStructure
export const useHandleNafLocationsRoutes = (): ReturnType => {
  const { pathname } = useLocation();
  const { data } = useSiteStructure(pathname.split('/')[1]) || {};
  const nafLocationPath = data?.slug;
  return {
    locations: locations.reduce((acc, curr) => {
      acc[curr.slug] = { ...curr, fullUrl: `/${nafLocationPath}/${curr.slug}` };
      return acc;
    }, {} as LocationsMapType),
    ...data,
  };
};

export { NafLocationSlugs };
